<form #mapForm="ngForm" autocomplete="off">
    <mat-form-field class="fullWidth" >
        <mat-label>Name</mat-label>
        <input matInput required [(ngModel)]="data.data.name"  name="name" required>
        <mat-error>
            Name is <strong>required</strong>
        </mat-error>
    </mat-form-field>
    <ac-input-container label="Use time conditions">
        <ac-select [(acModel)]="data.data.tbrConditionsIds"
                [items]="data.timeConditionsOptions"
                [allowClear]="true"
                [multiple]="true"
                [bindValue]="'id'"
                [bindLabel]="'name'">
        </ac-select>
    </ac-input-container>
</form>
